/** Wetter an Aktivitäten (ADR 0011): Symbol in Listen, Karte im Detail, Analyse, Rekorde, Wrapped, Einstellungen. */
export default {
  kind: {
    clear: 'Sonnig',
    partly: 'Leicht bewölkt',
    cloudy: 'Bewölkt',
    fog: 'Nebel',
    drizzle: 'Niesel',
    rain: 'Regen',
    snow: 'Schnee',
    storm: 'Gewitter',
  },
  /** Himmelsrichtung, aus der der Wind kommt (8 Sektoren ab Nord). */
  compass: {
    n: 'N', ne: 'NO', e: 'O', se: 'SO', s: 'S', sw: 'SW', w: 'W', nw: 'NW',
  },
  badge: '{kind}, {temp}',
  card: {
    aria: 'Wetter',
    title: 'Wetter',
    feels: 'Gefühlt',
    startEnd: 'Start → Ende',
    wind: 'Wind',
    windValue: '{speed} aus {dir}',
    windTip: 'Wind kommt aus {deg}° ({dir}); der Pfeil zeigt, wohin er weht',
    gusts: 'Böen',
    precip: 'Niederschlag',
    dry: 'trocken',
    clouds: 'Bewölkung',
    humidity: 'Luftfeuchte',
    routeWind: 'Wind entlang der Route',
    head: 'Gegenwind',
    cross: 'Seitenwind',
    tail: 'Rückenwind',
    headComponent: 'Ø {value} Gegenwind-Anteil',
    tailComponent: 'Ø {value} Rückenwind-Anteil',
    calm: 'kaum Wind – Richtung spielt keine Rolle',
    routeTip: 'Fahrtrichtung je Abschnitt gegen die Windrichtung zur Stunde: ±45° Gegenwind, ab 135° Rückenwind, dazwischen Seitenwind; nach Strecke gewichtet.',
    forecast: 'Modellstand der letzten Tage; die Reanalyse folgt nicht automatisch.',
    foot: 'Stündliche Modellwerte am auf ~1 km gerundeten Startort, kein Messwert vor Ort.',
    attribution: 'Wetterdaten: {provider} ({license})',
  },
  analysis: {
    titleRun: 'Pace und Puls nach Temperatur',
    titleRide: 'Schnitt nach Gegenwind',
    subRun: 'Ein Punkt pro Lauf ab 1 km · Linie: Median je Temperaturklasse',
    subRide: 'Ein Punkt pro Fahrt · x: mittlere Gegenwind-Komponente entlang der Route (negativ = Rückenwind)',
    xTemp: 'Temperatur °C',
    xHead: 'Gegenwind km/h',
    median: 'Median je Klasse',
    bin: '{label}: n = {n}',
    binLow: '{label}: n = {n}, zu wenige',
    nLow: '{n} – zu wenige',
    tableLabel: 'Klasse',
    tableN: 'Einheiten',
    tablePace: 'Median Pace',
    tableSpeed: 'Median Tempo',
    tableMpb: 'm / Schlag',
    lowNote: 'Klassen unter {n} Einheiten sind blass und zählen für die Aussage nicht.',
    without: { one: '{count} Einheit ohne Wetter (Indoor, ohne GPS oder noch nicht geholt).', other: '{count} Einheiten ohne Wetter (Indoor, ohne GPS oder noch nicht geholt).' },
    empty: 'Noch keine Einheiten mit Wetter.',
    off: 'Wetter ist in den Einstellungen ausgeschaltet.',
    chartLabel: { one: 'Streudiagramm mit {count} Einheit gegen das Wetter.', other: 'Streudiagramm mit {count} Einheiten gegen das Wetter.' },
    tip: '{date} · {temp} · {value}',
    tipRide: '{date} · Gegenwind {head} · {value}',
  },
  records: {
    title: 'Wetter-Rekorde',
    sub: { one: 'Aus {count} Einheit mit Wetter (Open-Meteo)', other: 'Aus {count} Einheiten mit Wetter (Open-Meteo)' },
    empty: 'Noch keine Einheiten mit Wetter.',
    aria: '{label}: {value}, {when}',
  },
  wrapped: {
    kicker: 'Wetter · {short}',
    label: '{title} {text}',
  },
  settings: {
    status: 'Status',
    on: 'An',
    off: 'Aus',
    switchOn: 'An – ausschalten',
    switchOff: 'Aus – einschalten',
    switchLabel: 'Wetter an Aktivitäten',
    counts: '{with} von {gps} Aktivitäten mit GPS haben Wetter, {pending} offen · {files} Antworten im Archiv',
    lastRun: 'Letzter Abruf {ago}: {requests} Anfragen',
    lastError: 'Letzter Abruf {ago} abgebrochen: {error}',
    backfill: 'Erster Nachlauf für die ganze Historie: {cmd} (mit {dry} nur zählen). Danach kommt Wetter nach jedem Sync und Import von selbst.',
    sent: 'Gesendet wird nur: Startort auf zwei Nachkommastellen gerundet (~1 km), Zeitraum, Liste der Wetterwerte. Indoor-Einheiten und solche ohne GPS bekommen kein Wetter.',
    source: 'Quelle',
    license: 'Lizenz',
  },
};
